module.exports = __webpack_public_path__ + "static/media/group_copy_2@3x.57039bd3.jpg";